import request from '@/api/config/request'

const prex = "api/simples_nacional/optante";

export function simplesNacionalAtualizaOptante(eco_codigo) {
    return request({
        url: `${prex}/${eco_codigo}`,
        method: 'get'
    })
}
